import { useEffect } from 'react';

/**
 * Tints the browser chrome (Android Chrome address bar, iOS Safari toolbar on versions that honor it)
 * and the area behind the page (overscroll bounce) while the calling page is mounted,
 * then restores whatever was there before. Pages that don't call it keep the default from index.html.
 */
export function useThemeColor(color: string) {
  useEffect(() => {
    let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    const created = !meta;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'theme-color';
      document.head.appendChild(meta);
    }
    const previousColor = meta.content;
    const root = document.documentElement;
    const previousBackground = root.style.backgroundColor;

    meta.content = color;
    root.style.backgroundColor = color;

    return () => {
      root.style.backgroundColor = previousBackground;
      if (created) meta?.remove();
      else if (meta) meta.content = previousColor;
    };
  }, [color]);
}
